import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEqual from 'react-fast-compare'
;
import withResources from '../HOCRecources'
import ResourceModal from '../../Components/Recources/resourceModal'
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  Circle,
  Polygon,
  Tooltip,
  Polyline,
  Marker,
  ZoomControl,
  LayersControl
} from 'react-leaflet'
import parse from 'html-react-parser';import { EditControl } from 'react-leaflet-draw'
import { addGeoFence, updateGeoFence } from './../../Actions/Devices'
import Layout from './../../Layout'
import L from 'leaflet'
import { MapPagination } from './../../Components/Maps/MapPagination'
import { convertSpeedUnits, errorHandler } from '../../Helpers'
import GeofenceModal from '../../Components/Geofence/GeofenceModal'
// import TrackModal from '../../Components/Geofence/KMLTracksModal'
import CustomMarker from './../../Components/Maps/CustomMarker'
import { MapTooltip } from './../../Components/Maps/MapTooltip'
import { MapTileLayers } from '../../Reducers/Maps'
import moment from "moment"
import instance from '../../axios'
// import { toast } from 'react-toastify';
//import { checkPrivileges } from '../../Helpers/index'
import MarkerClusterGroup from './../../Components/Maps/MarkerClusterGroup'
import withTranslationWrapper from '../../HOC/withTranslation';

let geo = {}
class Geofences extends Component {
  constructor (props) {
    super(props)
    this.state = {
      minZoom: 3,
      lat: 25.097919,
      lng: 55.236683,
      zoom: 3,
      bounds: null,
      update: true,
      EditControlObject: {},
      newVector: {},
      updatedGeo: {},
      updateVisible: this.updateVisible.bind(this),
      cancelDrawing: this.cancelDrawing.bind(this),
      saveDrawing: this.saveDrawing.bind(this),
      undoDrawing: this.undoDrawing.bind(this),
      enableEditMap: this.enableEditMap.bind(this),
      cancelMapChanges: this.cancelMapChanges.bind(this),
      save: this.save.bind(this),
      DrawControl: {},
      Drawing: '',
      EditMode: false,
      fitBounds: {},
      resourceList: false,
      linkResource: false,
      initFetch: false,
      currentPage: 1,
      pagesize: 50,
      itemPagination: {
        items: [],
        total: 0,
        currentPage: 0,
        currentDevice: this.props.deviceId,
        hasNext: true,
        searchText: ''
      },
      geofenceModal: false,
      geofenceModalData: null,
      geofenceModalMaoData: {},
      currentLayer: null
    }

    this.addShape = this.addShape.bind(this)
    this.mapReference = this.mapReference.bind(this)
    this._onEditControlReady = this._onEditControlReady.bind(this)
    this._onDrawControlReady = this._onDrawControlReady.bind(this)
    this._onDrawStop = this._onDrawStop.bind(this)
    this._onDrawStart = this._onDrawStart.bind(this)
    this._onEditPath = this._onEditPath.bind(this)
    this._onEditStart = this._onEditStart.bind(this)
    this._saveShap = this._saveShap.bind(this)
    this.setBoundOptions = this.setBoundOptions.bind(this)
    this.setEditControlValue = this.setEditControlValue.bind(this)
    this.reactECref = {}
    this.markers = null
  }

  componentWillUnmount () {
    this.setState({
      minZoom: 3,
      lat: 25.097919,
      lng: 55.236683,
      zoom: 3,
      bounds: null,
      update: true,
      EditControlObject: {},
      newVector: {},
      updatedGeo: {},
      DrawControl: {},
      Drawing: '',
      EditMode: false,
      fitBounds: {},

      initFetch: false,
      currentPage: 1,
      pagesize: 50,
      itemPagination: {
        items: [],
        total: 0,
        currentPage: 0,
        currentDevice: this.props.deviceId,
        hasNext: true,
        searchText: ''
      },
      geofenceModal: false,
      geofenceModalData: null,
      geofenceModalMaoData: {}
    })
  }

    setEditControlValue (obj) {
    if (obj && obj.id) {
      this.setState({
        EditControlObject: { ...this.state.EditControlObject, [obj.id]: obj }
      })
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state)
  }

  setBoundOptions () {
    return {}
  }

  mapReference (el) {
    if (el) {
      this.map = el
      this.map && L.Control.geocoder({
        position: 'topright',
        placeholder: 'Search location...',
        defaultMarkGeocode: false,
        expand: 'click',
        geocoder: L.Control.Geocoder.nominatim({
          htmlTemplate: r => {
            return `<span class="leaflet-control-geocoder-address-context">${r.display_name}<br>`
          }
        })
      })
        .on('finishgeocode', e => {
          e.target._alts.childNodes.forEach(el => (el.innerHTML = 'hello'))
        })
        .on('markgeocode', e => {
          this.map && this.map.fitBounds([[e.geocode.center.lat, e.geocode.center.lng]])
          this.setState({
            pointer: (
              <Marker
                position={[e.geocode.center.lat, e.geocode.center.lng]}
                icon={L.icon({
                  iconUrl: '/assets/images/location-pin.svg',
                  iconSize: [79, 64],
                  iconAnchor: [20, 64]
                })}
              />
            )
          })

          if (this.props.getPostion && this.map) {
            this.props.getPostion(e.geocode.center, this.map.getZoom())
          }
        })
        .addTo(this.map)
    }
  }

  componentWillMount () {
    if (this.props.ServerSetting&&this.props.ServerSetting.zoom) {
      this.setState({
        zoom: this.props.ServerSetting.zoom,
        lat: this.props.ServerSetting.latitude,
        lng: this.props.ServerSetting.longitude
      })
    }
    if (this.props.logInUser&&this.props.logInUser.zoom) {
      this.setState({
        zoom: this.props.logInUser.zoom,
        lat: this.props.logInUser.latitude,
        lng: this.props.logInUser.longitude
      })
    }
    if (
      this.props.logInUser &&
      this.props.logInUser.id &&
      this.props.geoFence.length &&
      this.state.initFetch === false
    ) {
      this.setState(
        {
          initFetch: true
        },
        () => {
          this.fetchData(
            this.props.logInUser.id,
            this.state.currentPage,
            this.state.pagesize
          )
          this.showUnits(this.props)
        }
      )
    }
  }

  componentWillReceiveProps (n) {
    if (n.ServerSetting.zoom) {
      this.setState({
        zoom: n.ServerSetting.zoom,
        lat: n.ServerSetting.latitude,
        lng: n.ServerSetting.longitude
      })
    }
    if (n.logInUser.zoom) {
      this.setState({
        zoom: n.logInUser.zoom,
        lat: n.logInUser.latitude,
        lng: n.logInUser.longitude
      })
    }

    if (n.logInUser && n.logInUser.id && n.geoFence.length) {
      this.setState(
        {
          initFetch: true
        },
        () => {
          this.fetchData(
            n.logInUser.id,
            this.state.currentPage,
            this.state.pagesize
          )
        }
      )

    }
      this.showUnits(n)
  }
  showResources = (type) => {
    this.setState({
      resourceList: type
    })
  }
  addResource = () =>{
    this.setState({
      isVisable: true,
      showItemDetail: false,
      activeOperation: 'addResource',
      selecteditem: '',
      driverAddress: '',
      driverLat: '',
      driverLon: ''
    })
  }
  onEditResource = (item) =>{
    this.setState({
      isVisable: true,
      showItemDetail: false,
      activeOperation: 'editResource',
      selecteditem: item,
      driverAddress: '',
      driverLat: '',
      driverLon: ''
    })
  }
  onLinkResource = (item) =>{
    this.setState({
      linkResource: true,
      selecteditem: item,
    },()=>{this.props.fetchNestedItems(item.id,1)})
  }
  onCloseResource = () =>{
    this.setState({
      linkResource: false,
    });
    this.onCloseModal();
  }
  onCloseModal = () => {
    this.setState({
      isVisable: false,
      showItemDetail: false,
      selecteditem: '',
      activeOperation: '',
      onDeleteConfirmation: false
    })
  }
  showUnits = (n) => {
    if (
      n.deviceRelatedData &&
      Object.keys(n.deviceRelatedData).length
    ) {
      this.markers = []
      n.devices.data && n.devices.data.map((deviceData, index) => {
        const position = n.deviceRelatedData[deviceData.id]
        const driver =
          n.drivers &&
          n.drivers.find(
            dr =>
              position &&
              position.exists &&
              position.driverId &&
              position.driverId === dr.id
          )
          const trailer =
          n.trailers &&
          n.trailers.find(
            t =>
              position &&
              position.exists &&
              position.attributes.trailerUniqueId &&
              position.attributes.trailerUniqueId === t.uniqueId
            )
        if (
          position &&
          position.exists &&
          deviceData &&
          deviceData.visible === true
        ) {
          this.markers.push(
            <CustomMarker
              key={deviceData.id}
              position={{ lat: position.latitude, lng: position.longitude, updated: moment(position.serverTime) }}
              rotationAngle={0}
              rotationOrigin='center'
              animationTime={
                deviceData.id === this.props.trackId &&
                this.state.animCount === 1
                  ? position.animationTime
                  : 0.5
              }
              tracking={this.props.trackId}
              icon={L.divIcon({
                iconUrl:
                  '/assets/category/default/' +
                  (deviceData.category || 'default') +
                  'top.svg',
                iconSize: [50, 50],
                iconAnchor: [25, 25],
                tooltipAnchor: [0, -20],
                className: 'custom-marker',
                html: `<img
                  style="transform: rotate(${position.course}deg)"
                    src=
                      '/assets/category/default/${deviceData.category ||
                        'default'}top.svg'
                    
                    alt=''
                  />`
              })}
              iconSize={[50, 50]}
            >
              <Tooltip direction={'top'}>
                <MapTooltip
                  trailer={trailer}
                  themecolors={this.props.themecolors}
                  position={position}
                  driver={driver}
                  device={deviceData}
                  logInUser={this.props.logInUser}
                  translate={this.props.translate}
                />
              </Tooltip>
            </CustomMarker>
          )
        }
        return null
      })
    } else {
      this.markers = null
    }
  }

  fetchMoreItems = () => {
    this.fetchData(
      this.props.logInUser.id,
      this.state.currentPage,
      this.state.pagesize
    )
  }

  searchItems = text => {
    this.setState(
      {
        searchText: text
      },
      () => {
        this.fetchData(this.props.logInUser.id, 1, this.state.pagesize, true)
      }
    )
  }

  fetchData = () => {
    let searchText = this.state.searchText
    let items = this.props.geoFence.filter(e =>
      e.name.toLowerCase().includes((searchText || '').toLowerCase())
    )
    // console.log("items=====", items);
    this.setState({
      itemPagination: {
        items: items.map(e => ({
          ...e,
          name: e.name,
          // name: parse(e.name),
          description: e.description
        })),
        total: items.length,
        currentPage: 1,
        hasNext: false
      }
    })
  }
  onDelete = () => {
    this.fetchData()
  }
  openGeofenceModal = async(data) => {
    if(this.map) {
      let geofenceModalMaoData = {
        center: this.map.getCenter(),
        zoom: this.map.getZoom()
      }
      this.setState({
        geofenceModal: true,
        geofenceModalData: data,
        geofenceModalMaoData
      })
    }
  }
  closeGeofenceModal = () => {
    this.setState({
      geofenceModal: false,
      geofenceModalData: null,
      geofenceModalMaoData: {}
    })
  }

  addShape (type) {
    if (this.state.EditMode === false) {
      if (this.state.DrawControl) {
        this.setState({ Drawing: type }, () => {
          if (type === 'circle') {
            this.state.DrawControl._toolbars.draw._toolbarContainer.children[2].click()
          } else if (type === 'polygon') {
            this.state.DrawControl._toolbars.draw._toolbarContainer.children[1].click()
          } else if (type === 'polyline') {
            this.state.DrawControl._toolbars.draw._toolbarContainer.children[0].click()
          }
        })
      }
    } else {
      alert('Please finish your modification first!')
    }
  }

  save (obj) {
    this.setState({ geo: obj }, () => {
      if (
        this.state.EditControlObject[obj.id]._toolbars.edit._actionButtons[0]
      ) {
        this.state.EditControlObject[
          obj.id
        ]._toolbars.edit._actionButtons[0].button.click()
      }
    })
  }

  enableEditMap (id) {
    setTimeout(() => {
      if (this.state.EditControlObject[id]) {
        this.setState({ EditMode: true })
        this.state.EditControlObject[
          id
        ]._toolbars.edit._toolbarContainer.children[0].click()
      }
    }, 100)
  }

  cancelMapChanges (id) {
    if (this.state.EditControlObject[id]) {
      this.setState({ EditMode: false }, () => {
        this.state.EditControlObject[
          id
        ]._toolbars.edit._actionButtons[1].button.click()
      })
    }
  }

  _onDrawControlReady (reactECref) {
    this.setState({ DrawControl: reactECref })
  }

  _onDrawStart (e) {
    this.setState({
      Drawing: e.layerType
    })
  }

  _onDrawStop (e) {
    let currentShap = {}
    Object.keys(e.target._targets).map(id => {
      if (parseInt(id) !== e.target._containerId) {
        currentShap = e.target._targets[id]
      }
      return null
    })

    if (Object.keys(currentShap).length) {
      if (currentShap.options.newShap) {
        if (this.state.Drawing === 'circle') {
          this.setState(
            {
              newVector: {
                name: 'New Circle',
                calendarId: 0,
                description: '',
                area:
                  'CIRCLE (' +
                  currentShap._latlng.lat +
                  ' ' +
                  currentShap._latlng.lng +
                  ', ' +
                  currentShap._mRadius +
                  ')',
                attributes: {
                  type: 'circle',
                  radius: currentShap._mRadius,
                  color: currentShap.options.color,
                  latlng: [currentShap._latlng.lat, currentShap._latlng.lng]
                }
              }
            },
            () => {
              this._saveShap(this.state.newVector)
            }
          )
        } else if (this.state.Drawing === 'polygon') {
          if (currentShap._latlngs) {
            let prepare = currentShap._latlngs[0].map(pos => {
              return '' + pos.lat + ' ' + pos.lng + ''
            })
            this.setState(
              {
                newVector: {
                  name: 'New Polygon',
                  calendarId: 0,
                  description: '',
                  area: 'POLYGON((' + prepare.join(', ') + '))',
                  attributes: {
                    type: 'polygon',
                    color: currentShap.options.color,
                    latlng: currentShap._latlngs[0]
                  }
                }
              },
              () => {
                this._saveShap(this.state.newVector)
              }
            )
          }
        } else if (this.state.Drawing === 'polyline') {
          let distance = 0
          let prepare = currentShap._latlngs.map((pos, index) => {
            distance += pos.distanceTo(currentShap._latlngs[index - 1] || pos)
            return '' + pos.lat + ' ' + pos.lng + ''
          })
          this.setState(
            {
              newVector: {
                name: 'New Polyline',
                calendarId: 0,
                description: '',
                area: 'LINESTRING (' + prepare.join(', ') + ')',
                attributes: {
                  type: 'polyline',
                  color: currentShap.options.color,
                  latlng: currentShap._latlngs,
                  polylineDistance: distance / 1000
                }
              }
            },
            () => {
              this._saveShap(this.state.newVector)
            }
          )
        }
      }
    } else {
      this.setState({ Drawing: '' })
    }
  }

  cancelDrawing () {
    if (this.state.Drawing === 'polygon' || this.state.Drawing === 'polyline') {
      this.state.DrawControl._toolbars.draw._actionButtons[2].button.click()
    }
    if (this.state.Drawing === 'circle') {
      this.state.DrawControl._toolbars.draw._actionButtons[0].button.click()
    }
    this.setState({ Drawing: '' })
  }

  saveDrawing () {
    if (this.state.Drawing === 'polygon' || this.state.Drawing === 'polyline') {
      this.state.DrawControl._toolbars.draw._actionButtons[0].button.click()
    }
  }

  undoDrawing () {
    if (this.state.Drawing === 'polygon' || this.state.Drawing === 'polyline') {
      this.state.DrawControl._toolbars.draw._actionButtons[1].button.click()
    }
  }

  _onEditControlReady (reactECref) {
    setTimeout(() => {
      if (reactECref) {
        var key = Object.keys(
          reactECref._toolbars.edit.options.featureGroup._layers
        )
        if (key.length) {
          var id =
            reactECref._toolbars.edit.options.featureGroup
              ._layers[key].options.id

          this.reactECref[id] = reactECref

          this.setState(
            {
              EditControlObject: {
                ...this.state.EditControlObject,
                [id]: reactECref
              }
            },
            () => {
              //this.enableEditMap(id);
            }
          )
        }
      }
    }, 50)
  }

  _onEditStart (id) {
    if (this.reactECref[id]) {
      this.setEditControlValue(this.state.EditControlObject)
      this.updateVisible()
    }
  }

  _saveShap (updatedItem) {
    // fetch(`api/geofences`, {
    //   method: 'POST',
    //   headers: {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({ ...updatedItem })
    // })
    instance({
      url: `api/geofences`,
      method: `POST`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      data:{
        ...updatedItem
      }
    })
    // .then(response => {
    //   if (response.ok) {
    //     response.json()
        .then(geofence => {
          this.props.dispatch(addGeoFence([{ ...geofence, visible: true }]))
          this.setState(
            {
              newVector: {},
              Drawing: ''
            },
            () => {
              this.state.DrawControl._toolbars.edit._toolbarContainer.children[1].click()
              if (
                this.state.DrawControl._toolbars.edit
                  ._actionButtons &&
                this.state.DrawControl._toolbars.edit
                  ._actionButtons[2]
              ) {
                this.state.DrawControl._toolbars.edit._actionButtons[2].button.click()
              }
            }
          )
      //   })
      // }
      // else{
      //   throw response
      // }
    }).catch(error => {errorHandler(error, this.props.dispatch)})
  }

  _onEditPath (id, e) {
    if (this.reactECref[id]) {
      this.setState(
        {
          EditControlObject: {
            ...this.state.EditControlObject,
            [id]: this.reactECref[id]
          }
        },
        () => {
          let layers = e.layers
          let item = this.state.geo
          let attributes = item ? item.attributes : {}
          let updatedItem = this.state.geo || {}
          let jsonObj

          layers.eachLayer(layer => {
            jsonObj = layer.toGeoJSON()
            if (jsonObj.geometry.type === 'Point') {
              var latlng2 = jsonObj.geometry.coordinates
              updatedItem = {
                ...item,
                area:
                  'CIRCLE (' +
                  latlng2[1] +
                  ' ' +
                  latlng2[0] +
                  ', ' +
                  layer._mRadius +
                  ')',
                attributes: {
                  ...attributes,

                  type: 'circle',
                  latlng: [latlng2[1], latlng2[0]],
                  radius: layer._mRadius
                }
              }
            } else if (jsonObj.geometry.type === 'Polygon') {
              item = this.state.geo
              var latlng22 = jsonObj.geometry.coordinates
              var p22 = []
              let prepare = latlng22[0].map(pos => {
                p22.push([pos[1], pos[0]])
                return '' + pos[1] + ' ' + pos[0] + ''
              })
              updatedItem = {
                ...item,
                area: 'POLYGON((' + prepare.join(', ') + '))',
                attributes: { ...attributes, type: 'polygon', latlng: p22 }
              }
            } else if (jsonObj.geometry.type === 'LineString') {
              item = this.state.geo
              var latlng23 = jsonObj.geometry.coordinates
              var p23 = []
              let prepare = latlng23.map(pos => {
                p23.push([pos[1], pos[0]])

                return '' + pos[1] + ' ' + pos[0] + ''
              })
              updatedItem = {
                ...item,
                area: 'LINESTRING (' + prepare.join(', ') + ')',
                attributes: { ...attributes, type: 'polyline', latlng: p23, imported: false, }
              }
            }
          })

          if (
            this.state.updatedGeo[id] === false ||
            this.state.updatedGeo[id] === undefined
          ) {
            if (updatedItem && updatedItem.visible !== undefined) {
              delete updatedItem.visible
            }
            if (
              updatedItem &&
              updatedItem.attributes &&
              updatedItem.attributes.speedLimit
            ) {
              updatedItem.attributes.speedLimit = convertSpeedUnits(
                updatedItem.attributes.speedLimit || 0,
                'kmh',
                'kn'
              )
            }
            this.setState({
              updatedGeo: {
                [id]: true
              }
            })

            // fetch(`api/geofences/${id}`, {
            //   method: 'PUT',
            //   headers: {
            //     Accept: 'application/json',
            //     'Content-Type': 'application/json'
            //   },
            //   body: JSON.stringify({ ...updatedItem })
            // })
            instance({
              url: `api/geofences/${id}`,
              method: `PUT`,
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              data:{
                ...updatedItem
              }
            })
            // .then(response => {
            //   if (response.ok) {
            //     response.json()
                .then(geofence => {
                  this.setState({
                    updatedGeo: {
                      [id]: false
                    },
                    EditMode: false
                  })
                  this.props.dispatch(
                    updateGeoFence({ ...geofence, visible: false })
                  )
                  this.props.dispatch(
                    updateGeoFence({ ...geofence, visible: true })
                  )
              //   })
              // }
              // else{
              //   throw response
              // }
            }).catch(error => {errorHandler(error, this.props.dispatch)})
          }
        }
      )
    }
  }

  onFeatureGroupAdd = (e, b) => {
    geo[b] = e.target.getBounds()
    this.setState({
      fitBounds: {
        ...geo
      }
    }, () => {
      let bounds = []
      this.props.geoFence.map(g => {
        if (g.visible === true && this.state.fitBounds[g.id]) {
          bounds.push(this.state.fitBounds[g.id])
        }
        return null
      })
      if(!bounds.length) {
        geo = Object.assign({})
      }
    })
  }

  toggleGeofences = checked => {
    if(!checked) {
      this.setState({fitBounds: {}})
      geo = {}
    }
    else {
      this.updateVisible();
    }
  }


  updateVisible () {
    setTimeout(() => {
      let bounds = []
      this.props.geoFence.map(g => {
        if (g.visible === true && this.state.fitBounds[g.id]) {
          bounds.push(this.state.fitBounds[g.id])
        }
        return null
      })
      if (bounds.length) {
        this.map.fitBounds(bounds)
      }
    }, 50)
  }

  changeBaseLayer = event => {
    
    if(this.map) {
      const center = this.map.getCenter(); 
      this.map.options.crs = ['yandexMap', 'yandexSat'].includes(event.layer.options && event.layer.options.id) ? L.CRS.EPSG3395 : L.CRS.EPSG3857;
      this.map.setView(center);
    }
    
    this.setState({currentLayer: event.layer.options});
    
  }

  render () {

    const endMessage =
      this.state.itemPagination && this.state.itemPagination.total > 0 ? (
        <p style={{ textAlign: 'center', color: '#ccc' }}>
          {' '}
          -- {this.props.translate('end')} --{' '}
        </p>
      ) : (
        <p style={{ textAlign: 'center', color: '#ccc' }}>
          {' '}
          {this.props.translate('notFound')}{' '}
        </p>
      )
    if (this.props.mapLayer) {
      const settings = {
        rectangle: false,
        circle: false,
        circlemarker: false,
        marker: false,
        polyline: false,
        polygon: false
      }
      let bounds ;
      const geofences = this.props.geoFence.map(obj => {
        if (obj && obj.attributes.type === 'circle' && obj.visible === true) {
          return (
            <FeatureGroup
              // onAdd={e => this.onFeatureGroupAdd(e, obj.id)}
              // ref={this._onFeatureGroupReady}
              eventHandlers={{
                add: (e) => {
                  this.onFeatureGroupAdd(e, obj.id)
                },
              }}
              key={obj.id}
            >
              <EditControl
                onMounted={this._onEditControlReady}
                position='bottomleft'
                draw={settings}
                onEdited={this._onEditPath.bind(this, obj.id)}
                onEditStart={this._onEditStart.bind(this, obj.id)}
              />
              <Circle
                id={obj.id}
                radius={obj.attributes.radius}
                center={obj.attributes.latlng}
                color={obj.attributes.color}
              >
                <Tooltip direction={'top'} permanent>
                  <div>
                    {/* <span>{parse(obj.name)}</span> */}
                    <span>{obj.name}</span>
                  </div>
                </Tooltip>
              </Circle>
            </FeatureGroup>
          )
        } else if (
          obj &&
          obj.attributes.type === 'polygon' &&
          obj.visible === true
        ) {
          return (
            <FeatureGroup
            eventHandlers={{
              add: (e) => {
                this.onFeatureGroupAdd(e, obj.id)
              },
            }}
              // onAdd={e => this.onFeatureGroupAdd(e, obj.id)}
              // ref={this._onFeatureGroupReady}
              key={obj.id}
            >
              <EditControl
                onMounted={this._onEditControlReady}
                position='bottomleft'
                draw={settings}
                edit={{ remove: false }}
                onEdited={this._onEditPath.bind(this, obj.id)}
                onEditStart={this._onEditStart.bind(this, obj.id)}
              />
              <Polygon
                id={obj.id}
                key={obj.id + '__1'}
                positions={obj.attributes.latlng}
                color={obj.attributes.color}
              >
                <Tooltip direction={'top'} permanent>
                  <div>
                    <span>{obj.name}</span>
                  </div>
                </Tooltip>
              </Polygon>
            </FeatureGroup>
          )
        } else if (
          obj &&
          obj.attributes.type === 'polyline' &&
          obj.visible === true
        ) {
          return (
            <FeatureGroup
              // onAdd={e => this.onFeatureGroupAdd(e, obj.id)}
              // ref={this._onFeatureGroupReady}
              eventHandlers={{
                add: (e) => {
                  this.onFeatureGroupAdd(e, obj.id)
                },
              }}
              key={obj.id}
            >
              <EditControl
                onMounted={this._onEditControlReady}
                position='bottomleft'
                draw={settings}
                edit={{ remove: false }}
                onEdited={this._onEditPath.bind(this, obj.id)}
                onEditStart={this._onEditStart.bind(this, obj.id)}
              />
              <Polyline
                id={obj.id}
                key={obj.id + '__1'}
                positions={obj.attributes.latlng}
                color={obj.attributes.color}
              >
                <Tooltip direction={'top'} permanent>
                  <div>
                    <span>{obj.name}</span>
                  </div>
                </Tooltip>
              </Polyline>
            </FeatureGroup>
          )
        }

        return ''
      })

      const position = [this.state.lat, this.state.lng]
      const drawOptions = {
        shapeOptions: {
          color: this.props.themecolors&&this.props.themecolors.themeDarkColor,
          opacity: 1,
          newShap: true
        }
      }
      const drawSettings = {
        ...settings,
        circle: drawOptions,
        polygon: drawOptions,
        polyline: drawOptions
      }

      const body = [
        <>
          <FeatureGroup>
            <EditControl
              ref={this._onDrawControlReady}
              draw={drawSettings}
              position='bottomleft'
              onDrawStop={this._onDrawStop}
              onDrawStart={this._onDrawStart}
            />
          </FeatureGroup>
          {/* start */}
          {/* {this.props.logInUser.attributes &&
          this.props.logInUser.attributes.clusters ? (
            <MarkerClusterGroup key={1}>{this.markers}</MarkerClusterGroup>
          ) : (
            this.markers
          )} */}
          {/* end */}
          {geofences}
          <ZoomControl position={'bottomright'} />
          <MapPagination  translate={this.props.translate} />
        </>
      ]

      const thisMap = [
        <MapContainer
          key={1}
          ref={this.mapReference}
          zoomControl={false}
          style={{ height: this.props.height, width: this.props.width }}
          center={position}
          zoom={this.state.zoom}
          onBaselayerchange={this.changeBaseLayer}
          maxZoom={this.props.mapLayer.maxZoom}
          bounds={bounds && bounds.length ? this.map?.fitBounds(bounds) : null}
        >
          {this.state.pointer}
          {body}
          <LayersControl position="bottomright">
            {MapTileLayers.map(layer => <LayersControl.BaseLayer id={layer.id} checked={layer.id === this.props.mapLayer.id} key={layer.id} name={layer.name}>
              <TileLayer {...layer} minZoom={this.state.minZoom} />    
            </LayersControl.BaseLayer>)}
          </LayersControl>
        </MapContainer>
      ]
      return (
        <div className='no-map-controls no-widgets'>
          {this.state.geofenceModal &&  this.state.resourceList !== 'tracks'  && (
            <>            
            <GeofenceModal
              translate={this.props.translate}
              geofence={this.state.geofenceModalData}
              {...this.state.geofenceModalMaoData}
              onClose={this.closeGeofenceModal}
              resourceList={this.state.resourceList}
            />
            </>

          )}
          <Layout
            {...this.props}
            geofenceData={this.state}
            toggleGeofences={this.toggleGeofences}
            fetchMoreItems={this.fetchMoreItems}
            itemPagination={{ ...this.state.itemPagination, endMessage }}
            searchItems={this.searchItems}
            openGeofenceModal={this.openGeofenceModal}
            onDelete={this.onDelete}
            showResources={this.showResources}
            onEditResource={this.onEditResource}
            onLinkResource={this.onLinkResource}
            addResource={this.addResource}
            resourceList={this.state.resourceList}
          >
            {!['addResource', 'editResource'].includes(this.state.activeOperation) ? <div>
            {['osm', ''].includes(this.props.mapLayer.id) ? thisMap : null}
            {['carto'].includes(this.props.mapLayer.id) ? thisMap : null}
            {['googleTerrain'].includes(this.props.mapLayer.id)
              ? thisMap
              : null}
            {['googleSatellite'].includes(this.props.mapLayer.id)
              ? thisMap
              : null}
            {['googleHybrid'].includes(this.props.mapLayer.id) ? thisMap : null}
            {['googleRoad'].includes(this.props.mapLayer.id) ? thisMap : null}
            {['baidu'].includes(this.props.mapLayer.id) ? thisMap : null}
            {['yandexMap', 'yandexSat'].includes(this.props.mapLayer.id)
              ? thisMap
              : null}
              </div> : null}

            <button
              style={{
                position: 'absolute',
                left: '-10000px',
                top: '-10000px'
              }}
              onClick={() => this.addShape('circle')}
              id='addCircle'
            ></button>
            <button
              style={{
                position: 'absolute',
                left: '-10000px',
                top: '-10000px'
              }}
              onClick={() => this.addShape('polygon')}
              id='addPolygon'
            ></button>
            <button
              style={{
                position: 'absolute',
                left: '-10000px',
                top: '-10000px'
              }}
              onClick={() => this.addShape('polyline')}
              id='addPolyline'
            ></button>   
            <div className="has-padding">
            <ResourceModal
            
              changeResource={this.props.changeResource}
              selectedResourse={this.state.selecteditem}
              activeOperation={this.state.activeOperation}
              onCloseResource={this.onCloseResource}
              itemPagination={this.state.itemPagination&&this.state.itemPagination.items}
              assignItem={this.props.assignItem}
              unassignItem={this.props.unassignItem}
              fetchNestedItems={this.props.fetchNestedItems}
              nestedResources={this.props.nestedResources}
              translate={this.props.translate}
              editResource={this.state.editResource}
              linkResource={this.state.linkResource}
              themecolors={this.props.themecolors}
              itemType='Geofence'
            />
            </div>
          </Layout>
        </div>
      )
    } else {
      return null
    }
  }
}

const mapStateToProps = state => ({
  geoFence: state.geoFence,
  deviceRelatedData: state.deviceRelatedData,
  devices: state.devices,
  mapLayer: state.mapLayer,
  logInUser: state.logInUsers,
  themecolors: state.themeColors,
  ServerSetting: state.ServerSetting
})

export default connect(mapStateToProps)((withResources(withTranslationWrapper(Geofences, 'Geofence'))))
